/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { LayoutContext } from "App/common/hoc/Layout";
import { SPopupContext } from "App/common/hoc/SlidingPopup";
import { VALIDATION } from "consts";
import { NOTIFICATION_STATUS } from "App/componentsConfig";
import { deepCompare, forbidExtraProps, deepClone, validDates } from "utils";

import {
  updateBackupSettingsStart,
  cancelEditBackupSetting,
  toggleScheduleType,
  cleanCache,
  initiateBackup,
  toggleScheduleDevice
} from "store/actions";
import { CONTENT } from "consts";

function Footer(props) {
  const { lState, lMethods } = useContext(LayoutContext);
  const { sPopupState, sPopupMethods } = useContext(SPopupContext);
  const sPopupRef = React.useRef();
  const lStateRef = React.useRef();

  /*****************************Handling  popup using enter key ***************************/
  useEffect(() => {
    lStateRef.current = lState;
    sPopupRef.current = sPopupState;

    const handleKeyDown = e => {
      if (
        e.key === "Enter" &&
        lStateRef.current.slidingPopup.show &&
        sPopupRef.current.popup.show
      ) {
        if (sPopupRef.current.popup.alertName === "saveOrDiscardChanges") {
          sPopupRef.current.popup.params.execute();
        } else if (
          sPopupRef.current.popup.alertName === "saveOrDiscardSMTPChanges"
        ) {
          sPopupRef.current.popup.params.execute();
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.addEventListener("keydown", handleKeyDown);
    };
  }, [sPopupState]);

  //check for change in backup setting and show discard popup.
  useEffect(() => {
    if (sPopupState.notify.show) sPopupMethods.closeNotify();
    const backupSettings = JSON.parse(JSON.stringify(props.backupSettings));
    const cachedSettings = JSON.parse(JSON.stringify(props.cachedSettings));

    delete backupSettings?.preChanged;
    delete cachedSettings?.preChanged;

    if (
      backupSettings.scheduleInfo.type.current !==
      props.enums.ScheduleType.CUSTOM
    ) {
      delete backupSettings.scheduleInfo.weekDays;
      delete cachedSettings.scheduleInfo.weekDays;
    }

    delete backupSettings.scheduleInfo.type.past;
    delete cachedSettings.scheduleInfo.type.past;
    delete backupSettings.scheduleInfo.scheduleChanged;
    delete cachedSettings.scheduleInfo.scheduleChanged;
    delete backupSettings.volumes.sourceType;
    delete cachedSettings.volumes.sourceType;

    Object.keys(backupSettings.volumes.list).forEach(vol => {
      delete backupSettings.volumes.list[vol].semichecked;
    });
    Object.keys(backupSettings.volumes.list).forEach(vol => {
      delete cachedSettings.volumes.list[vol].semichecked;
    });

    if (sPopupState.refresh.show) {
      sPopupMethods.disableClose(true, {});
      props.cleanCache("backupSettings");
    } else if (!deepCompare(backupSettings, cachedSettings)) {
      sPopupMethods.disableClose(false, {
        display: discardTo =>
          sPopupMethods.openPopup("saveOrDiscardChanges", {
            execute: () => {
              sPopupMethods.closePopup();
              updateSettings();
            },
            cancel: true,
            secondExecute: () => {
              if (discardTo === "layout") lMethods.closeSlidingPopup();
              else if (discardTo === "backToSummary") {
                cancelEditSetting();
                sPopupMethods.disableClose(true, {});
                sPopupMethods.closePopup();
              } else {
                sPopupMethods.disableClose(true, {});
                sPopupMethods.closePopup();
                discardTo();
                sPopupMethods.closeValidation();
              }
            }
          })
      });
    } else if (!sPopupState.disableClose.close) {
      sPopupMethods.disableClose(true, {});
    }
  }, [props.backupSettings]);

  useEffect(() => {
    if (sPopupState.notify.params) {
      const timer = setTimeout(() => {
        sPopupMethods.closeNotify();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [sPopupState.notify.show]);

  const scheduleInfo = useCallback((data, settings) => {
    data.type = data.type.current;

    //If all days are selection change type to Daily
    if (
      data.type === props.enums.ScheduleType.CUSTOM &&
      data.weekDays.length === 7
    ) {
      data.type = props.enums.ScheduleType.DAILY;
      props.toggleScheduleType(props.enums.ScheduleType.DAILY);
    }
    data.startTime = data.startTime.value;
    if (data.weekDays.length > 0) data.weekDays.sort();

    //Validation
    settings.validation = {
      status: true,
      msg: "Schedule",
      params: {}
    };
    if (
      data.type === props.enums.ScheduleType.CUSTOM &&
      data.weekDays.length === 0
    ) {
      settings.validation.status = false;
      settings.validation.params = {
        ...settings.validation.params,
        ...{
          emptyWeekdays: {
            check: true,
            msg: VALIDATION.backupSettings.schedule.emptyWeekdays
          }
        }
      };
    }
    if (
      data.type === props.enums.ScheduleType.MONTHLY &&
      (data.months.length === 0 || data.monthDays.length === 0)
    ) {
      settings.validation.status = false;
      settings.validation.params = {
        ...settings.validation.params,
        ...{
          emptyMonths: {
            check: true,
            msg: VALIDATION.backupSettings.schedule.emptyMonths
          }
        }
      };
    } else if (
      data.type === props.enums.ScheduleType.MONTHLY &&
      !validDates(data.months, data.monthDays)
    ) {
      settings.validation.status = false;
      settings.validation.params = {
        ...settings.validation.params,
        ...{
          validDates: {
            check: true,
            msg: VALIDATION.backupSettings.schedule.validDates
          }
        }
      };
    }
    // if (
    //   data.advanced.onWakeup.checked &&
    //   data.advanced.onWakeup.password.length === 0
    // ) {
    //   settings.validation.status = false;
    //   settings.validation.params = {
    //     ...settings.validation.params,
    //     ...{
    //       emptyPassword: {
    //         check: true,
    //         msg: VALIDATION.backupSettings.schedule.emptyPassword
    //       }
    //     }
    //   };
    // }
    // if (
    //   data.advanced.onWakeup.checked &&
    //   data.advanced.onWakeup.password.length < 6 &&
    //   data.advanced.onWakeup.password.length > 0
    // ) {
    //   settings.validation.status = false;
    //   settings.validation.params = {
    //     ...settings.validation.params,
    //     ...{
    //       emptyPassword: {
    //         check: true,
    //         msg: VALIDATION.backupSettings.schedule.minimumPassword
    //       }
    //     }
    //   };
    // }
    // if (
    //   data.advanced.onWakeup.checked &&
    //   data.advanced.onWakeup.userName.length === 0
    // ) {
    //   settings.validation.status = false;
    //   settings.validation.params = {
    //     ...settings.validation.params,
    //     ...{
    //       emptyUserName: {
    //         check: true,
    //         msg: VALIDATION.backupSettings.schedule.emptyUserName
    //       }
    //     }
    //   };
    // }

    //Logs
    let scheduleChange = false;
    if (data.type !== props.cachedSettings.scheduleInfo.type) {
      scheduleChange = true;
    } else {
      switch (data.type) {
        case props.enums.ScheduleType.INTERVAL:
          data.scheduleInfo.startTime.value !==
            props.cachedSettings.scheduleInfo.startTime.value ||
          data.scheduleInfo.interval.selected !==
            props.cachedSettings.scheduleInfo.interval.selected
            ? (scheduleChange = true)
            : (scheduleChange = false);
          break;
        case props.enums.ScheduleType.DAILY:
          data.scheduleInfo.startTime.value !==
          props.cachedSettings.scheduleInfo.startTime.value
            ? (scheduleChange = true)
            : (scheduleChange = false);
          break;
        case props.enums.ScheduleType.CUSTOM:
          data.scheduleInfo.startTime.value !==
            props.cachedSettings.scheduleInfo.startTime.value ||
          JSON.stringify(data.scheduleInfo.weekDays) !==
            JSON.stringify(props.cachedSettings.scheduleInfo.weekDays)
            ? (scheduleChange = true)
            : (scheduleChange = false);
          break;
        // TODO: review
        case props.enums.ScheduleType.MONTHLY:
          data.scheduleInfo.startTime.value !==
            props.cachedSettings.scheduleInfo.startTime.value ||
          JSON.stringify(data.scheduleInfo.months) !==
            JSON.stringify(props.cachedSettings.scheduleInfo.months) ||
          JSON.stringify(props.scheduleInfo.monthDays) !==
            JSON.stringify(
              props.cachedSettings.scheduleInfo.scheduleInfo.monthDays
            )
            ? (scheduleChange = true)
            : (scheduleChange = false);
        default:
          scheduleChange = false;
      }
    }

    if (
      !deepCompare(data.advanced, props.cachedSettings.scheduleInfo.advanced) &&
      scheduleChange
    ) {
      settings.log = {
        mode: "scheduleInfo",
        params: scheduleInfoLog(data, "multiple")
      };
    } else if (
      !deepCompare(data.advanced, props.cachedSettings.scheduleInfo.advanced)
    ) {
      settings.log = {
        mode: "scheduleInfo",
        params: scheduleInfoLog(data, "advance")
      };
    } else if (scheduleChange) {
      settings.log = {
        mode: "scheduleInfo",
        params: scheduleInfoLog(data, data.type)
      };
    }

    return data;
  }, []);

  const emailNotification = useCallback(
    (data, settings) => {
      settings.validation = {
        status: true,
        msg: "",
        params: {}
      };

      data.enable = true;

      delete data.enabled;
      data.currentEmail = data.emails.current;
      data.emails = data.emails.list;

      if (data.emails.length > 0) {
        data.enable = true;
      } else {
        data.enable = false;
      }

      if (data.operationStatus.onSuccess && data.operationStatus.onFailure) {
        data.operationStatus = 0;
      } else {
        if (data.operationStatus.onSuccess) data.operationStatus = 1;
        else if (
          !data.operationStatus.onSuccess &&
          data.operationStatus.onFailure
        )
          data.operationStatus = 2;
        else data.operationStatus = 3;
      }

      //Validate
      settings.validation.status = true;
      data = validateEmailSettings(data, settings);
      if (settings.validation.status) {
        // Log
        if (
          !deepCompare(
            data.emails,
            props.cachedSettings.emailNotification.emails.list
          )
        ) {
          settings.log = {
            mode: "email",
            params: createEmailLog(data, "email")
          };
        } else if (
          !deepCompare(
            data.smtpSettings,
            props.cachedSettings.emailNotification.smtpSettings
          )
        ) {
          settings.log = {
            mode: "email",
            params: createEmailLog(data, "smtp")
          };
        } else if (
          !deepCompare(
            props.backupSettings.emailNotification.operationStatus,
            props.cachedSettings.emailNotification.operationStatus
          )
        ) {
          settings.log = {
            mode: "email",
            params: createEmailLog(data, "enableDisableEmailNotifications")
          };
        }
      }

      return data;
    },
    [props.backupSettings]
  );

  const volumes = useCallback((data, settings) => {
    const drives = [];
    const selectedVolumes = [];
    let empty = true;

    if (Object.keys(data.list).length > 0) {
      for (let key in data.list) {
        const temp = {
          deviceId: data.list[key].deviceId,
          volume: []
        };
        for (let volKey in data.list[key].volume) {
          temp.volume.push(data.list[key].volume[volKey]);

          if (data.list[key].volume[volKey].checked) {
            empty = false;
            selectedVolumes.push(data.list[key].volume[volKey].label);
          }
        }

        drives.push(temp);
      }
    }

    // Validation
    if (empty) {
      settings.validation = {
        status: false,
        msg: VALIDATION.backupSettings.source.emptyVolumes
      };
    } else settings.validation = { status: true };

    // logs
    settings.log = {
      mode: "source",
      params: { volumes: selectedVolumes, sourceType: data.sourceType }
    };

    return drives;
  }, []);

  const advancesettings = useCallback((cleanup, performance, settings) => {
    //log
    if (
      !deepCompare(cleanup, props.cachedSettings.cleanup) &&
      !deepCompare(performance, props.cachedSettings.performance)
    ) {
      settings.log = {
        mode: "advance",
        params: "Advanced Settings changed"
      };
    } else if (!deepCompare(cleanup, props.cachedSettings.cleanup)) {
      settings.log = {
        mode: "advance",
        params: "Cleanup Settings changed"
      };
    } else if (!deepCompare(performance, props.cachedSettings.performance)) {
      settings.log = {
        mode: "advance",
        params: "Performance Settings changed"
      };
    }

    return { cleanup, performance };
  }, []);

  const updateSettings = () => {
    let updateFlag = false;
    const backupSettings = JSON.parse(JSON.stringify(props.backupSettings));
    const settings = {
      backupType: backupSettings.backupType,
      validation: { ...sPopupState.validation },
      log: {}
    };

    switch (props.currentPanel.type) {
      case "schedule":
        if (
          !deepCompare(
            backupSettings.scheduleInfo,
            props.cachedSettings.scheduleInfo
          )
        ) {
          updateFlag = true;
          settings.scheduleInfo = scheduleInfo(
            backupSettings.scheduleInfo,
            settings
          );
        }
        if (
          !deepCompare(
            backupSettings.cutOffTime,
            props.cachedSettings.cutOffTime
          )
        ) {
          updateFlag = true;
          settings.cutOffTime = backupSettings.cutOffTime;
          if (!settings.log || (settings.log && !settings.log.mode)) {
            settings.log = {
              mode: "scheduleInfo",
              params: scheduleInfoLog(settings.cutOffTime, "cutOffTime")
            };
          }
        }
        if (
          !deepCompare(
            backupSettings.emailNotification.notifyOnDesktop,
            props.cachedSettings.emailNotification.notifyOnDesktop
          )
        ) {
          updateFlag = true;
          settings.emailNotification = emailNotification(
            backupSettings.emailNotification,
            settings
          );
          if (!settings.log || (settings.log && !settings.log.mode)) {
            settings.log = {
              mode: "email",
              params: createEmailLog(
                backupSettings.emailNotification,
                "notifyOnDesktop"
              )
            };
          }
        }

        if (backupSettings.scheduleInfo.advanced.startBackupImmediately) {
          settings.scheduleInfo.advanced.startBackupImmediately = false;
          props.toggleScheduleDevice("startBackupImmediately");
          props.initiateBackup(backupSettings.clientDetails.clientUUID, true);
        }

        break;
      case "email":
        settings.validation = {
          status: true,
          msg: "",
          params: {}
        };
        if (
          !deepCompare(
            backupSettings.emailNotification,
            props.cachedSettings.emailNotification
          )
        ) {
          updateFlag = true;
          settings.emailNotification = emailNotification(
            backupSettings.emailNotification,
            settings
          );
        }
        break;
      case "source":
        if (
          !deepCompare(backupSettings.volumes, props.cachedSettings.volumes)
        ) {
          updateFlag = true;
          settings.volumes = volumes(backupSettings.volumes, settings);
        }
        break;
      case "advanceSettings":
        if (
          !deepCompare(backupSettings.cleanup, props.cachedSettings.cleanup) ||
          !deepCompare(
            backupSettings.performance,
            props.cachedSettings.performance
          )
        ) {
          updateFlag = true;
          const { cleanup, performance } = advancesettings(
            backupSettings.cleanup,
            backupSettings.performance,
            settings
          );
          settings.cleanup = cleanup;
          settings.performance = performance;
        }
        break;
      default:
        break;
    }

    if (settings.validation.status) {
      if (
        props.backupSettings.emailNotification.emails.current.trim() !== "" &&
        !props.backupSettings.emailNotification.emails.current.includes(",")
      ) {
        props.backupSettings.emailNotification.emails.list.push(
          props.backupSettings.emailNotification.emails.current
        );
        props.backupSettings.emailNotification.emails.current = "";
      }
      delete settings.validation;
      if (props.currentPanel.type === "source")
        sPopupMethods.closeNotify("source");
      if (Object.keys(settings.log).length)
        settings.log = JSON.stringify(settings.log);
      else delete settings.log;
      if (!sPopupState.validation.status) sPopupMethods.closeValidation();

      if (updateFlag)
        if (
          props.currentPanel.type === "email" &&
          settings.emailNotification.emails.length < 1 &&
          (settings.emailNotification.currentEmail === "" ||
            settings.emailNotification.currentEmail.includes(","))
        ) {
          sPopupMethods.openPopup("saveOrDiscardSMTPChanges", {
            execute: () => {
              removeSMTPSettings(settings, props.backupSettings);
              if (
                !deepCompare(
                  backupSettings.emailNotification.smtpSettings,
                  props.cachedSettings.emailNotification.smtpSettings
                )
              )
                props.updateBackupSettingsStart(
                  settings,
                  backupSettings.clientDetails.clientUUID
                );
              sPopupMethods.closePopup();
              sPopupMethods.disableClose(true, {});
              props.switchPanel("summary");
            },
            cancel: true,
            secondExecute: () => {
              sPopupMethods.closePopup();
            }
          });
        } else {
          if (lState.slidingPopup.alertName !== "enablePC")
            props.updateBackupSettingsStart(
              settings,
              backupSettings.clientDetails.clientUUID
            );
          sPopupMethods.disableClose(true, {});
          props.switchPanel("summary");
        }
      else props.switchPanel("summary");
    } else {
      if (props.currentPanel.type === "source") {
        sPopupMethods.showNotify({
          msg: VALIDATION.backupSettings.source.emptyVolumes,
          status: NOTIFICATION_STATUS.warning.name
        });
      } else if (
        props.backupSettings.scheduleInfo.type.current ===
          props.enums.ScheduleType.CUSTOM &&
        props.backupSettings.scheduleInfo.weekDays.length === 0
      ) {
        sPopupMethods.showNotify({
          msg: VALIDATION.backupSettings.schedule.emptyWeekdays,
          status: NOTIFICATION_STATUS.warning.name
        });
      } else if (
        props.backupSettings.scheduleInfo.type.current ===
          props.enums.ScheduleType.MONTHLY &&
        (props.backupSettings.scheduleInfo.months.length === 0 ||
          props.backupSettings.scheduleInfo.monthDays.length === 0)
      ) {
        sPopupMethods.showNotify({
          msg: VALIDATION.backupSettings.schedule.emptyMonths,
          status: NOTIFICATION_STATUS.warning.name
        });
      } else if (
        props.backupSettings.scheduleInfo.type.current ===
          props.enums.ScheduleType.MONTHLY &&
        !validDates(
          props.backupSettings.scheduleInfo.months,
          props.backupSettings.scheduleInfo.monthDays
        )
      ) {
        sPopupMethods.showNotify({
          msg: VALIDATION.backupSettings.schedule.validDates,
          status: NOTIFICATION_STATUS.warning.name
        });
      }
      sPopupMethods.showValidation(settings.validation);
    }
  };

  function removeSMTPSettings(settings, backupSettings) {
    settings.emailNotification.smtpSettings = {
      password: "",
      port: 0,
      serverName: "",
      userName: ""
    };
    backupSettings.emailNotification.smtpSettings = {
      password: "",
      port: 0,
      serverName: "",
      userName: ""
    };
  }

  function validateEmailSettings(emailSettings, settings) {
    if (emailSettings.currentEmail.split(",").length > 1) {
      let emailsList = emailSettings.currentEmail.split(",");
      let correctEmails = [];
      let wrongEmails = [];
      let duplicateEmails = [];
      //props.emailNotification.emails.current = newEmail.split(",");
      for (let i = 0; i < emailsList.length; i++) {
        if (
          /^([!#-\'*+\/-9=?A-Z^-~\\\\-]{1,64}(\.[!#-\'*+\/-9=?A-Z^-~\\\\-]{1,64})*|"([\]!#-[^-~\ \t\@\\\\]|(\\[\t\ -~]))+")@([0-9A-Z]([0-9A-Z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Z]([0-9A-Z-]{0,61}[0-9A-Za-z])?))+$/i.test(
            emailsList[i].replace(" ", "")
          )
        ) {
          if (
            emailSettings.emails.includes(emailsList[i].replace(" ", "")) ||
            correctEmails.includes(emailsList[i].replace(" ", ""))
          ) {
            duplicateEmails.push(emailsList[i].replace(" ", ""));
          } else correctEmails.push(emailsList[i].replace(" ", ""));
        } else wrongEmails.push(emailsList[i].replace(" ", ""));
      }
      if (wrongEmails.length > 0) {
        settings.validation.status = false;
        settings.validation.params = {
          ...settings.validation.params,
          ...{
            email: {
              check: true,
              msg: VALIDATION.backupSettings.email.valid
            }
          }
        };
      } else if (duplicateEmails.length > 0) {
        settings.validation.status = false;
        settings.validation.params = {
          ...settings.validation.params,
          ...{
            email: {
              check: true,
              msg: VALIDATION.backupSettings.email.duplicate
            }
          }
        };
      }
      wrongEmails.push.apply(wrongEmails, duplicateEmails);
      emailSettings.emails.push.apply(emailSettings.emails, correctEmails);
      props.backupSettings.emailNotification.emails.list.push.apply(
        props.backupSettings.emailNotification.emails.list,
        correctEmails
      );
      emailSettings.currentEmail = wrongEmails.join(", ");
      props.backupSettings.emailNotification.emails.current = wrongEmails.join(
        ", "
      );
    } else {
      if (emailSettings.emails.includes(emailSettings.currentEmail)) {
        settings.validation.status = false;
        settings.validation.params = {
          ...settings.validation.params,
          ...{
            email: {
              check: true,
              msg: VALIDATION.backupSettings.email.duplicate
            }
          }
        };
      } else if (
        /^([!#-\'*+\/-9=?A-Z^-~\\\\-]{1,64}(\.[!#-\'*+\/-9=?A-Z^-~\\\\-]{1,64})*|"([\]!#-[^-~\ \t\@\\\\]|(\\[\t\ -~]))+")@([0-9A-Z]([0-9A-Z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Z]([0-9A-Z-]{0,61}[0-9A-Za-z])?))+$/i.test(
          emailSettings.currentEmail
        )
      ) {
        emailSettings.emails.push(emailSettings.currentEmail.trim());
        emailSettings.currentEmail = "";
      } else if (emailSettings.currentEmail.trim() !== "") {
        settings.validation.status = false;
        settings.validation.params = {
          ...settings.validation.params,
          ...{
            email: {
              check: true,
              msg: VALIDATION.backupSettings.email.valid
            }
          }
        };
      }
    }
    if (emailSettings.emails.length < 1) {
      emailSettings.smtpSettings.isEnabled = false;
      emailSettings.smtpSettings = {
        serverName: "",
        userName: "",
        password: "",
        port: ""
      };
    }
    if (emailSettings.smtpSettings.isEnabled) {
      if (
        emailSettings.emails.length > 0 ||
        emailSettings.currentEmail.trim() !== ""
      ) {
        if (
          emailSettings.smtpSettings.serverName.trim() === "" ||
          emailSettings.smtpSettings.serverName.length < 3
        ) {
          settings.validation.status = false;
          settings.validation.params = {
            ...settings.validation.params,
            ...{
              servername: {
                check: true,
                msg: VALIDATION.backupSettings.smtp.servername
              }
            }
          };
        }
        if (
          emailSettings.smtpSettings.userName.trim() === "" ||
          emailSettings.smtpSettings.userName.length < 3
        ) {
          settings.validation.status = false;
          settings.validation.params = {
            ...settings.validation.params,
            ...{
              username: {
                check: true,
                msg: VALIDATION.backupSettings.smtp.username
              }
            }
          };
        }
        if (
          emailSettings.smtpSettings.password.trim() === "" ||
          emailSettings.smtpSettings.password.length < 4
        ) {
          settings.validation.status = false;
          settings.validation.params = {
            ...settings.validation.params,
            ...{
              password: {
                check: true,
                msg: VALIDATION.backupSettings.smtp.password
              }
            }
          };
        }
        if (
          emailSettings.smtpSettings.port === "" ||
          emailSettings.smtpSettings.port < 1 ||
          emailSettings.smtpSettings.port > 65535
        ) {
          settings.validation.status = false;
          settings.validation.params = {
            ...settings.validation.params,
            ...{
              port: {
                check: true,
                msg: VALIDATION.backupSettings.smtp.port
              }
            }
          };
        }
      }
    }
    return emailSettings;
  }

  function createEmailLog(emailData, mode) {
    if (mode === "email") {
      let addedEmailArray = [];
      let removedArray = [];
      let diffArray = emailData.emails
        .filter(
          x => !props.cachedSettings.emailNotification.emails.list.includes(x)
        )
        .concat(
          props.cachedSettings.emailNotification.emails.list.filter(
            x => !emailData.emails.includes(x)
          )
        );
      if (diffArray.length > 0) {
        addedEmailArray = diffArray.filter(x => emailData.emails.includes(x));
        removedArray = diffArray.filter(x => !emailData.emails.includes(x));
      }
      return { addedEmails: addedEmailArray, removedEmails: removedArray };
    } else if (mode === "smtp") {
      return { smtp: emailData.smtpSettings };
    } else if (mode == "enableDisableEmailNotifications") {
      let notifyOnFailure;
      let notifyOnSuccess;
      if (emailData.operationStatus === 0) {
        return { notifyOnFailure: true, notifyOnSuccess: true };
      } else if (emailData.operationStatus === 1) {
        return { notifyOnFailure: false, notifyOnSuccess: true };
      } else if (emailData.operationStatus === 2) {
        return { notifyOnFailure: true, notifyOnSuccess: false };
      } else if (emailData.operationStatus === 3) {
        return { notifyOnFailure: false, notifyOnSuccess: false };
      }

      //return {operationStatus:emailData.operationStatus}
    } else if ((mode = "notifyOnDesktop")) {
      return { notifyOnDesktop: emailData.notifyOnDesktop };
    }
  }

  function scheduleInfoLog(data, mode) {
    switch (mode) {
      case props.enums.ScheduleType.INTERVAL:
      case props.enums.ScheduleType.DAILY:
      case props.enums.ScheduleType.CUSTOM:
      case props.enums.ScheduleType.MONTHLY:
      case props.enums.ScheduleType.NO_SCHEDULE:
        return {
          ...data
        };
      case "multiple":
        return { type: mode };
      case "advance":
        return { type: mode };
      case "cutOffTime":
        return { type: mode };
      default:
        break;
    }
  }

  const cancelEditSetting = useCallback(() => {
    const settings = {};

    switch (props.currentPanel.type) {
      case "schedule":
        settings.scheduleInfo = props.cachedSettings.scheduleInfo;
        settings.cutOffTime = props.cachedSettings.cutOffTime;
        break;
      case "encryption":
        settings.encryption = props.cachedSettings.encryption;
        break;
      case "source":
        settings.volumes = props.cachedSettings.volumes;
        break;
      case "email":
        settings.emailNotification = props.cachedSettings.emailNotification;
        break;
      case "advanceSettings":
        settings.cleanup = props.cachedSettings.cleanup;
        settings.performance = props.cachedSettings.performance;
        break;
      default:
        break;
    }
    sPopupMethods.closeValidation();
    props.cancelEditBackupSetting(deepClone(settings));
    props.switchPanel("summary");
  }, [props.currentPanel, props.cachedSettings]);

  return (
    <div className="summary_wrap_footer">
      <div className="summary_wrap_btns">
        {sPopupState.refresh.show || sPopupState.disableClose.close ? (
          <div className="slider_btn btn_disable">Save Changes</div>
        ) : (
          <div className="slider_btn btn_primary" onClick={updateSettings}>
            {CONTENT.backupSettings.buttons.save}
          </div>
        )}

        <div
          className="slider_btn slider_btn_cancel"
          onClick={cancelEditSetting}
        >
          {CONTENT.backupSettings.buttons.cancel}
        </div>
      </div>
    </div>
  );
}

Footer.propTypes = forbidExtraProps(
  {
    currentPanel: PropTypes.object,
    backupSettings: PropTypes.object,
    cachedSettings: PropTypes.object,
    enums: PropTypes.object
  },
  [
    "switchPanel",
    "updateBackupSettingsStart",
    "cancelEditBackupSetting",
    "toggleScheduleType",
    "cleanCache"
  ]
);

function mapStateToProps(state) {
  return {
    backupSettings: state.backupSettings,
    cachedSettings: state.common.backupSettings,
    enums: state.common.enums
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateBackupSettingsStart,
      cancelEditBackupSetting,
      toggleScheduleType,
      cleanCache,
      toggleScheduleDevice,
      initiateBackup
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
